import { render, staticRenderFns } from "./userlevel.vue?vue&type=template&id=8c1b91d6"
import script from "./userlevel.vue?vue&type=script&lang=js"
export * from "./userlevel.vue?vue&type=script&lang=js"
import style0 from "./userlevel.vue?vue&type=style&index=0&id=8c1b91d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports